import containerFuild from '../html-snippets/container-fuild.js';
import dividerPrimary from '../../../views/website/products/components/description/ui-modules/divider-primary/raw-html.js';
import css from '../css-snippets/fastvaluedeal-compare-benefits';

const dividerLeftHtml = dividerPrimary({
  show: true,
  maxWidth: 200,
  height: 1,
  align: 'right',
  backgroundColor: '#FFFFFF',
});

const dividerRightHtml = dividerPrimary({
  show: true,
  maxWidth: 200,
  height: 1,
  align: 'left',
  backgroundColor: '#FFFFFF',
});

const featureItemHtml = ({ text = '', imageSrc = '' }) => `
<div
  class="fvd-compare-benefits__feature-item"
  data-attribute="fvd-compare-benefits__feature-item"
>
  <div class="fvd-compare-benefits__feature-icon-wrap" data-attribute="fvd-compare-benefits__feature-icon-wrap">
    <img
      data-attribute="fvd-compare-benefits__feature-image"
      src="${imageSrc}"
      alt=""
    />
  </div>
  <div data-attribute="fvd-compare-benefits__feature-text" class="fvd-compare-benefits__feature-text">
    ${text}
  </div>
</div>`;

const defaultWithoutContent = `
<h3><strong>Life Without WaveMax</strong></h3>
<ul>
  <li><span style="color:#e53935;">✘</span>&nbsp;&nbsp;<span style="color:hsl( 0, 1%, 46% );">Signal interruptions</span></li>
  <li><span style="color:#e53935;">✘</span>&nbsp;&nbsp;<span style="color:hsl( 0, 1%, 46% );">High subscription fees</span></li>
  <li><span style="color:#e53935;">✘</span>&nbsp;&nbsp;<span style="color:hsl( 0, 1%, 46% );">Poor broadcast quality</span></li>
  <li><span style="color:#e53935;">✘</span>&nbsp;&nbsp;<span style="color:hsl( 0, 1%, 46% );">Dependant on wires</span></li>
  <li><span style="color:#e53935;">✘</span>&nbsp;&nbsp;<span style="color:hsl( 0, 1%, 46% );">Poor channel selection</span></li>
</ul>
`;

const defaultWithContent = `
<h3><strong>Life With WaveMax</strong></h3>
<ul>
  <li><span style="color:#43a047;">✔</span>&nbsp;&nbsp;<span style="color:hsl( 0, 1%, 46% );">Strong and stable signal</span></li>
  <li><span style="color:#43a047;">✔</span>&nbsp;&nbsp;<span style="color:hsl( 0, 1%, 46% );">No subscription fees</span></li>
  <li><span style="color:#43a047;">✔</span>&nbsp;&nbsp;<span style="color:hsl( 0, 1%, 46% );">Full HD broadcast quality</span></li>
  <li><span style="color:#43a047;">✔</span>&nbsp;&nbsp;<span style="color:hsl( 0, 1%, 46% );">Compact and portable</span></li>
  <li><span style="color:#43a047;">✔</span>&nbsp;&nbsp;<span style="color:hsl( 0, 1%, 46% );">Endless channel selection</span></li>
</ul>
`;

const html = `
<div
  class="fvd-compare-benefits-content container"
  data-attribute="fvd-compare-benefits-content"
>
  <div
    class="fvd-compare-benefits__top"
    data-attribute="fvd-compare-benefits__top"
    data-background-color="#0130E2"
    data-text-color="#FFFFFF"
    style="--top-bg: #0130E2; --top-text: #FFFFFF;"
  >
    <div class="fvd-compare-benefits__top-header" data-attribute="fvd-compare-benefits__top-header">
      <div class="fvd-compare-benefits__top-divider fvd-compare-benefits__top-divider--left" data-attribute="fvd-compare-benefits__top-divider-left">
        ${dividerLeftHtml}
      </div>
      <div data-attribute="fvd-compare-benefits__top-title" class="fvd-compare-benefits__top-title">
        <h2 style="text-align:center;"><strong>Enjoy Unlimited Channel Selection with WaveMax</strong></h2>
      </div>
      <div class="fvd-compare-benefits__top-divider fvd-compare-benefits__top-divider--right" data-attribute="fvd-compare-benefits__top-divider-right">
        ${dividerRightHtml}
      </div>
    </div>
    <div
      class="fvd-compare-benefits__features"
      data-attribute="fvd-compare-benefits__features"
      data-columns="6"
      style="--columns: 6;"
    >
      ${featureItemHtml({
        text: '<p style="text-align:center;"><strong>SPORTS</strong></p>',
        imageSrc: 'https://cdn.skyfastimg.com/images/2026/06/04/image-6a2130d6808bb03837c3746f.png',
      })}
      ${featureItemHtml({
        text: '<p style="text-align:center;"><strong>NEWS</strong></p>',
        imageSrc: 'https://cdn.skyfastimg.com/images/2026/06/04/image-6a2130ed871d874bb842dd85.png?w=50&h=50&q=80',
      })}
      ${featureItemHtml({
        text: '<p style="text-align:center;"><strong>REALITY TV</strong></p>',
        imageSrc: 'https://cdn.skyfastimg.com/images/2026/06/04/image-6a2130fe081ea360f26fedf4.png?w=50&h=50&q=80',
      })}
      ${featureItemHtml({
        text: '<p style="text-align:center;"><strong>DOCUMENTARIES</strong></p>',
        imageSrc: 'https://cdn.skyfastimg.com/images/2026/06/04/image-6a213110eab21d74038a8e9b.png?w=50&h=50&q=80',
      })}
      ${featureItemHtml({
        text: '<p style="text-align:center;"><strong>CARTOONS</strong></p>',
        imageSrc: 'https://cdn.skyfastimg.com/images/2026/06/04/image-6a21311f1c42458a951f6b9e.png?w=50&h=50&q=80',
      })}
      ${featureItemHtml({
        text: '<p style="text-align:center;"><strong>MOVIES</strong></p>',
        imageSrc: 'https://cdn.skyfastimg.com/images/2026/06/04/image-6a21312f2e5e515aeaa785d2.png?w=50&h=50&q=80',
      })}
    </div>
  </div>
  <div class="fvd-compare-benefits__bottom" data-attribute="fvd-compare-benefits__bottom">
    <div
      class="fvd-compare-benefits__box fvd-compare-benefits__box--without"
      data-attribute="fvd-compare-benefits__box-without"
    >
      <div data-attribute="fvd-compare-benefits__box-without-content" class="fvd-compare-benefits__box-content">
        ${defaultWithoutContent}
      </div>
    </div>
    <div
      class="fvd-compare-benefits__box fvd-compare-benefits__box--with"
      data-attribute="fvd-compare-benefits__box-with"
      data-highlight-border="#0130E2"
      style="--highlight-border: #0130E2;"
    >
      <div data-attribute="fvd-compare-benefits__box-with-content" class="fvd-compare-benefits__box-content">
        ${defaultWithContent}
      </div>
    </div>
  </div>
</div>
`;

export default containerFuild(html, css);
